import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import { NavLink as RouterLink } from 'react-router';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import { useAppSelector } from '../../state/store';
import { getSensorsById } from '../../state/selectors';
import { sensorTypeDetails } from '../../utils/sensorProperties';
import SensorIcon from '../../styles/icons/SensorIcon';
import { knownOfflineTag } from './helpers';
import { ListOptions } from '../../Views/OfflineView';
import { getShortTimeStr } from '../../utils/functions';
import { DataTreeItem } from '../../services/api';
import { themeProps } from '../../styles/theme';

interface OfflineSensorSummaryProps {
  faultySensors: DataTreeItem[];
  listType: ListOptions;
  handleTagging: (sensors: DataTreeItem[], isTagged: boolean) => void;
}

function OfflineSensorSummary({
  faultySensors,
  listType,
  handleTagging,
}: OfflineSensorSummaryProps) {
  const sensorsById = useAppSelector(getSensorsById);

  return (
    <Box>
      {faultySensors.length > 0 &&
        faultySensors.map((sensor) => {
          const sensorDetails = sensorsById.get(sensor.id);
          const Icon =
            (sensorDetails?.type && sensorTypeDetails[sensorDetails.type]?.icon) ?? SensorIcon;
          const isTagged = !!sensorDetails?.tags?.includes(knownOfflineTag);
          return (
            <Grid
              container
              sx={{
                marginTop: '10px',
                alignItems: 'center',
                display: `${isTagged && listType === ListOptions.untagged ? 'none' : 'flex'}`,
              }}
              key={sensor.id}
            >
              <Grid item sm={1}>
                <Icon color="error" sx={{ cursor: 'pointer' }} />
              </Grid>
              <Grid item sm={3}>
                <Tooltip title={`Go to ${sensorDetails?.name} config page`} placement="top-start">
                  <Link component={RouterLink} to={`/sensors/${encodeURIComponent(sensor.id)}`}>
                    <ListItemText>{sensorDetails?.name}</ListItemText>
                  </Link>
                </Tooltip>
              </Grid>
              <Grid item sm={4} sx={{ cursor: 'pointer' }}>
                <span style={{ marginLeft: '20px' }}>-</span>
              </Grid>

              <Grid item sm={2} sx={{ cursor: 'pointer' }}>
                <Tooltip title="Last seen" placement="top-start">
                  <span>{getShortTimeStr(sensor?.time ?? 0)}</span>
                </Tooltip>
              </Grid>

              <Grid item sm={2} sx={{ textAlign: 'end' }}>
                <Button
                  onClick={() => handleTagging([sensor], isTagged)}
                  variant={themeProps.btnVariant.default}
                >
                  {isTagged ? 'isTagged' : 'Click to Tag'}
                </Button>
              </Grid>
            </Grid>
          );
        })}
    </Box>
  );
}

export default OfflineSensorSummary;
